import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAppStore = create(
  persist(
    (set) => ({
      user: null,
      setUser: (userData) => set({ user: userData }),
      clearUser: () => set({ user: null }),
      jwt: null,
      setJwt: (token) => set({ jwt: token }),
      clearJwt: () => set({ jwt: null }),
      
      // Menu visibility
      scorecard: null,
      qualScorecard: null,
      setScorecard: (value) => set({ scorecard: value }),
      setQualScorecard: (value) => set({ qualScorecard: value }),

      // Team users management
      teamUsersLeft: [], // Users available (not in team)
      teamUsersRight: [], // Users in team
      setTeamUsersLeft: (users) => set({ teamUsersLeft: users }),
      setTeamUsersRight: (users) => set({ teamUsersRight: users }),
      addToTeamUsersLeft: (user) => set((state) => ({ 
        teamUsersLeft: [...state.teamUsersLeft, user] 
      })),
      removeFromTeamUsersLeft: (userId) => set((state) => ({ 
        teamUsersLeft: state.teamUsersLeft.filter(u => u.id !== userId) 
      })),
      addToTeamUsersRight: (user) => set((state) => ({ 
        teamUsersRight: [...state.teamUsersRight, user] 
      })),
      removeFromTeamUsersRight: (userId) => set((state) => ({ 
        teamUsersRight: state.teamUsersRight.filter(u => u.id !== userId) 
      })),
      clearTeamUsers: () => set({ teamUsersLeft: [], teamUsersRight: [] }),
    }),
    {
      name: 'app-storage', 
    }
  )
);

export default useAppStore;
